import Parse from '../../parseConfig';

import { validateUserSession } from './validateUserSession';


/**
 * Fetches the map layers based on the region of the logged-in user.
 * The dictionary keys are based on the "type" property of each MapLayer object.
 * 
 * @returns {Object} A dictionary where keys are types and values are arrays of MapLayer objects.
 */

export const fetchMapLayers = async () => {

  try {

    const isValid = await validateUserSession();

    if (!isValid) {
      throw new Error('Invalid user session');
    }
    else {
      //console.log('FetchMapLayers: Valid user session');
    }

    const currentUser = Parse.User.current();  // Get the current logged-in user

    if (!currentUser) {
      throw new Error('No user is currently logged in.');
    }

    const builderPointer = currentUser.get('builder');  // Fetch the builder associated with the current user

    if (!builderPointer) {
      throw new Error('No builder associated with the current user.');
    }
    const builder = await builderPointer.fetch();

    const regionPointer = builder.get('region');  // Fetch the region associated with the builder
    if (!regionPointer) {
      throw new Error('No region associated with the builder.');
    }
    const region = await regionPointer.fetch();

    const MapLayer = Parse.Object.extend('MapLayer');  // Define the Parse Object for MapLayer

    const mapLayerQuery = new Parse.Query(MapLayer);  // Create a new query for the MapLayer class

    mapLayerQuery.equalTo('active', 1);  // Add a condition to only fetch active layers (active == 1)
    mapLayerQuery.equalTo('region', region);  // Add a condition to match the region of the MapLayer with the region of the builder
    mapLayerQuery.ascending('order');  // Sort the results in descending order based on the "order" field

    const mapLayerResults = await mapLayerQuery.find();  // Execute the query and get the results

    // Reduce the results into a dictionary organized by the "type" property
    const layersDictionary = mapLayerResults.reduce((layerAccumulator, currentLayer) => {

      const layerType = currentLayer.get('type');  // Get the type of the current layer

      // If the accumulator does not already have an array for this type, create one
      if (!layerAccumulator[layerType]) {
        layerAccumulator[layerType] = [];
      }

      layerAccumulator[layerType].push(currentLayer);  // Push the current layer to the array for this type

      return layerAccumulator;  // Return the updated accumulator

    }, {}); // Initialize the accumulator as an empty object

    // Ensure there is only one primary layer (if there are multiple, keep only the first one)
    if (layersDictionary.primary && layersDictionary.primary.length > 1) {
      layersDictionary.primary = [layersDictionary.primary[0]];
    }

    //console.log('Fetched layers dictionary:', layersDictionary);

    return layersDictionary;  // Return the dictionary of layers

  } catch (error) {

    console.error('Error fetching layers:', error);  // Log any errors that occur during the query

    return {  // Return an empty object in case of an error
      primary: [],
      secondary: [],
    };
  }
};
